export default "__VITE_ASSET__zyPgjbWU__"